import React from 'react';
import { makeStyles } from '@material-ui/core';
import cx from 'classnames';

import { Col, Row, units } from '@ha/dsl';
import { FeaturedCountries } from 'ha/constants/FeaturedCountries';
import { useOptionalHermes } from 'ha/modules/Hermes';

import CityInfo from './CityInfo';
import CityFAQ from './CityFAQ';
import SearchCategories from '../containers/SearchCategories';
import SearchPager from '../containers/SearchPager';
import SearchCollectionSubtitle from '../containers/SearchCollectionSubtitle';
import SearchCitiesNearby from '../containers/SearchCitiesNearby';
import SearchGuidesLinks from './SearchGuidesLinks';
import SearchPageBreadcrumbs from './SearchPageBreadcrumbs';
import { HermesData } from '../types';

interface Props {
  cityCanonical?: string;
  countryCanonical?: string;
  countryCode?: string;
  shouldShowCitiesNearby: boolean;
  cityLocalizedName?: string;
  countryLocalizedName?: string;
}

const useStyles = makeStyles(theme => ({
  seoMargin: {
    margin: units.yx(0.75, 0),
  },
  searchTips: {
    [theme.breakpoints.down('sm')]: {
      padding: units.yx(0, 0.5),
    },
  },
}));

const SearchResultsBottom: React.FC<Props> = ({
  cityLocalizedName,
  countryLocalizedName,
  shouldShowCitiesNearby,
  cityCanonical,
  countryCanonical,
  countryCode,
}) => {
  const classes = useStyles();
  const { data } = useOptionalHermes<HermesData>();

  return (
    <Row>
      <Col xs={12} className={classes.seoMargin}>
        <SearchPager />
      </Col>
      <Col xs={12} className={cx(classes.seoMargin, classes.searchTips)}>
        <SearchPageBreadcrumbs />
      </Col>
      <Col xs={12} className={classes.searchTips}>
        <SearchCollectionSubtitle />
      </Col>
      {data?.searchFaq && data.searchFaq.length > 0 && (
        <Col xs={12} className={cx(classes.seoMargin, classes.searchTips)}>
          <CityFAQ faq={data.searchFaq} />
        </Col>
      )}
      {data?.copyText && (
        <Col xs={12} className={cx(classes.seoMargin, classes.searchTips)}>
          <CityInfo text={data.copyText} />
        </Col>
      )}
      {!FeaturedCountries.includes(countryCode || '') && (
        <React.Fragment>
          <Col xs={12} className={cx(classes.seoMargin, classes.searchTips)}>
            <SearchCategories />
          </Col>
          <Col
            data-test-locator="Search Guides Links"
            xs={12}
            className={cx(classes.seoMargin, classes.searchTips)}
          >
            <SearchGuidesLinks
              cityCanonical={cityCanonical}
              countryCanonical={countryCanonical}
              cityLink={data?.cityPagePathname}
              countryLink={data?.countryPagePathname}
              cityLocalizedName={cityLocalizedName}
              countryLocalizedName={countryLocalizedName}
            />
          </Col>
          {shouldShowCitiesNearby && (
            <Col xs={12} className={cx(classes.seoMargin, classes.searchTips)}>
              <SearchCitiesNearby />
            </Col>
          )}
        </React.Fragment>
      )}
    </Row>
  );
};

export default SearchResultsBottom;
